import { Color } from "@opendaw/lib-std";
export const Colors = {
    white: new Color(0, 0, 100),
    // Jewel-tone Accents - Rich and sophisticated
    blue: new Color(215, 62, 56), // Sapphire Blue
    green: new Color(155, 52, 46), // Emerald Green
    yellow: new Color(45, 72, 56), // Topaz/Amber
    orange: new Color(25, 82, 56), // Burnt Orange
    red: new Color(355, 68, 52), // Ruby Red
    purple: new Color(275, 52, 56), // Amethyst
    cream: new Color(40, 38, 82), // Champagne/Gold tint for highlights
    // UI Grays & Backgrounds - "Black Card" Aesthetic
    bright: new Color(0, 0, 94), // Platinum/White text
    gray: new Color(220, 5, 48), // Gunmetal gray
    dark: new Color(220, 5, 22), // Dark metallic
    shadow: new Color(0, 0, 0), // Pure black shadow
    black: new Color(220, 10, 2), // Deepest void
    // Surface Colors
    background: new Color(240, 4, 6), // Matte Black (Main App)
    panelBackground: new Color(240, 3, 10), // Charcoal (Panels)
    panelBackgroundBright: new Color(240, 2, 15), // Lighter Charcoal (Active)
    panelBackgroundDark: new Color(240, 5, 4) // Near Black (Insets)
};
export const initializeColors = (root) => {
    Object.entries(Colors).forEach(([name, value]) => {
        const cssName = name.replace(/([A-Z])/g, "-$1").toLowerCase();
        root.style.setProperty(`--color-${cssName}`, value.toString());
    });
};
